import {getDate} from '../../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    }
}));

const getRows = (event_history) => {
    return event_history.map((item) => {
        return {
            id: item.id,
            date_event: getDate(item.date_event),
            action: <span style={{textTransform: 'uppercase'}}>{item.action}</span>,
            name: <span style={{textTransform: 'capitalize'}}>{item.name}</span>,
            login: parseLogin(item.login),
            currency: item.currency,
            amount: new Intl.NumberFormat('ru-RU').format(Math.floor(item.amount * 100) / 100) + '₽',
            client_transaction_id: item.client_transaction_id
        }
    })
} 

const columns = [
    {id: 'id', label: 'ID'},
    { id: 'date_event', label: 'Дата'},
    { id: 'action', label: 'Тип события'},
    { id: 'name', label: 'Игра'},
    { id: 'login', label: 'Логин'},
    { id: 'currency', label: 'Валюта'},
    { id: 'amount', label: 'Сумма'},
    { id: 'client_transaction_id', label: 'Транзакция'},
];

export {
    useStyles,
    getRows,
    columns
}